import { ISettingsPanelProps } from './types';
import * as React from 'react';
import './_SettingsPanel.scss';
import { CLASS_LIST_VIEW } from '../../constants';
import { ViewSettingsHOC } from '../../hocs/ViewSettingsHOC/ViewSettingsHOC';
import { FieldsColumnsHOC } from '../../hocs/FieldsColumnsHOC/FieldsColumnsHOC';
import { AnalyzeRender } from '../../../helpers/memoizeHelper';

// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`listView SettingsPanel`) : null;

export const SettingsPanel = ({
    boardId,
}: ISettingsPanelProps) => {
    if (analyzeRender) analyzeRender.call('SettingsPanel');

    const className = CLASS_LIST_VIEW + '-settings';

    return <div className={className}>
        <ViewSettingsHOC boardId={boardId} />
        <FieldsColumnsHOC boardId={boardId} />
    </div>;
}
